import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { getNounOverride } from "@whoosh/utilities/src/FormatNounOverride/getNounOverride";

import { useFacilityCourseNoun_facility$key } from "./__generated__/useFacilityCourseNoun_facility.graphql";

export const useFacilityCourseNoun = (
  facilityRef: useFacilityCourseNoun_facility$key | null,
  lowercaseFirstLetter?: boolean
) => {
  const facility = useFragment(
    useFacilityCourseNounFragmentString,
    facilityRef
  );
  const copyOverrides = facility?.copyOverrides?.course;

  return {
    singular: getNounOverride(
      copyOverrides?.singular,
      t`course`,
      !!lowercaseFirstLetter
    ),
    plural: getNounOverride(
      copyOverrides?.plural,
      t`courses`,
      !!lowercaseFirstLetter
    ),
  };
};

const useFacilityCourseNounFragmentString = graphql`
  fragment useFacilityCourseNoun_facility on Facility {
    copyOverrides {
      course {
        singular
        plural
      }
    }
  }
`;
